import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-signup-successful',
  templateUrl: './signup-successful.component.html',
  styleUrls: ['./signup-successful.component.css']
})
export class SignupSuccessfulComponent implements OnInit {
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  constructor() { }

  ngOnInit() {
    console.log('ngOnInit called'); // Add a console log to verify if ngOnInit is being called
    setTimeout(() => {
      this.closeModal.emit();
    }, 3000);
  }

}
